import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import {
  createAnswerItemsFromValues,
  getAnswerValuesFromItems
} from 'components/Assessments/helpers'
import {
  AdapterOptions,
  FlatAnswerMutation,
  SectionAdapter
} from 'components/Assessments/adapters/types'
import { ADLNeedFormDataItem } from './formData'
import { RecertFormData } from '../../types/RecertFormData'
import { RecertFormField } from '../../types/RecertFormField'
import { RecertAssessmentQuestionnaireItem } from '../../types/questionnaire'

export class ADLNeedsAdapter extends SectionAdapter<RecertFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<RecertFormData> {
    const adlNeedsAnswers =
      flatAnswers[RecertAssessmentQuestionnaireItem.ADL_NEEDS_NEED]?.answer ?? []
    const adlneedsFormData = adlNeedsAnswers?.map<ADLNeedFormDataItem>((adlAnswerItem) => {
      const adlInfoItem = adlAnswerItem.item ?? []

      const adlId = getAnswerValuesFromItems(
        adlInfoItem,
        RecertAssessmentQuestionnaireItem.ADL_NEEDS_NEED_ID
      )?.at(0)

      const adlName = getAnswerValuesFromItems(
        adlInfoItem,
        RecertAssessmentQuestionnaireItem.ADL_NEEDS_NEED_NAME
      )?.at(0)

      const adlObservationReference = getAnswerValuesFromItems(
        adlInfoItem,
        RecertAssessmentQuestionnaireItem.ADL_NEEDS_NEED_OBSERVATION_REFERENCE
      )?.at(0)

      const adlNewNote = getAnswerValuesFromItems(
        adlInfoItem,
        RecertAssessmentQuestionnaireItem.ADL_NEEDS_NEED_NEW_NOTE
      )?.at(0)

      const adlIsArchived = getAnswerValuesFromItems(
        adlInfoItem,
        RecertAssessmentQuestionnaireItem.ADL_NEEDS_NEED_IS_ARCHIVED
      )?.at(0)

      const adlLastNoteText = getAnswerValuesFromItems(
        adlInfoItem,
        RecertAssessmentQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_TEXT
      )?.at(0)

      const adlLastNoteAuthor = getAnswerValuesFromItems(
        adlInfoItem,
        RecertAssessmentQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_AUTHOR
      )?.at(0)

      const adlLastNoteDate = getAnswerValuesFromItems(
        adlInfoItem,
        RecertAssessmentQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_DATE
      )?.at(0)

      return {
        [RecertFormField.ADL_NEED_ID]: adlId,
        [RecertFormField.ADL_NEED_NAME]: adlName,
        [RecertFormField.ADL_NEED_OBSERVATION_REFERENCE]: adlObservationReference
          ? adlObservationReference.reference
          : undefined,
        [RecertFormField.ADL_NEED_NEW_NOTE]: adlNewNote,
        [RecertFormField.ADL_NEED_IS_ARCHIVED]: adlIsArchived,
        [RecertFormField.ADL_NEED_LAST_NOTE_TEXT]: adlLastNoteText,
        [RecertFormField.ADL_NEED_LAST_NOTE_AUTHOR]: adlLastNoteAuthor,
        [RecertFormField.ADL_NEED_LAST_NOTE_DATE]: adlLastNoteDate
      }
    })

    return {
      [RecertFormField.ADL_NEEDS]: adlneedsFormData
    }
  }
  buildFlatAnswers(formData: RecertFormData): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []
    if (formData[RecertFormField.ADL_NEEDS]) {
      const adlItemsAndValue = formData[RecertFormField.ADL_NEEDS]?.map((formData) => {
        const observationReference = formData[RecertFormField.ADL_NEED_OBSERVATION_REFERENCE]
        return {
          item: createAnswerItemsFromValues([
            [
              RecertAssessmentQuestionnaireItem.ADL_NEEDS_NEED_ID,
              formData[RecertFormField.ADL_NEED_ID]
            ],
            [
              RecertAssessmentQuestionnaireItem.ADL_NEEDS_NEED_OBSERVATION_REFERENCE,
              observationReference ? { reference: observationReference } : undefined
            ],
            [
              RecertAssessmentQuestionnaireItem.ADL_NEEDS_NEED_NAME,
              formData[RecertFormField.ADL_NEED_NAME]
            ],
            [
              RecertAssessmentQuestionnaireItem.ADL_NEEDS_NEED_NEW_NOTE,
              formData[RecertFormField.ADL_NEED_NEW_NOTE]
            ],
            [
              RecertAssessmentQuestionnaireItem.ADL_NEEDS_NEED_IS_ARCHIVED,
              formData[RecertFormField.ADL_NEED_IS_ARCHIVED]
            ],
            [
              RecertAssessmentQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_TEXT,
              formData[RecertFormField.ADL_NEED_LAST_NOTE_TEXT]
            ],
            [
              RecertAssessmentQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_AUTHOR,
              formData[RecertFormField.ADL_NEED_LAST_NOTE_AUTHOR]
            ],
            [
              RecertAssessmentQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_DATE,
              formData[RecertFormField.ADL_NEED_LAST_NOTE_DATE]
            ]
          ])
        }
      })
      mutations.push({
        linkId: RecertAssessmentQuestionnaireItem.ADL_NEEDS_NEED,
        value: adlItemsAndValue ?? []
      })
    }
    return mutations
  }
}
